/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';




// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');

Webfont.load({
    typekit: {
        id: 'lkz4zns',
    }
});

//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

import { initSvgImage } from './utilities/img-svg';
import smoothScroll from './utilities/smooth-scroll';
import initAnimations from './utilities/animations';

//--------------------------------------------------------------------//


// Init Utilies
//--------------------------------------------------------------------//

initSvgImage();

smoothScroll();

initAnimations();

//--------------------------------------------------------------------//


// Import Componenti
//--------------------------------------------------------------------//

import initHeader from 'components/header/header';

import searchBar from 'components/search-bar/search-bar';

import footer from 'components/footer/footer';

import bannerAdv from 'components/banner-adv/banner-adv';

import stripBannerAdv from 'components/strip-banner-adv/strip-banner-adv';

import videoYoutube from 'components/video-youtube/video-youtube';

import bannerNewsletter from 'components/banner-newsletter/banner-newsletter';

import accordion from 'imComponents/accordion/accordion';

//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//

initHeader();

accordion();

searchBar();

bannerAdv();

//--------------------------------------------------------------------//